module.exports = __webpack_public_path__ + "static/media/icon-about-facebook.ea3c26a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-about-facebook.svg
// module id = 521
// module chunks = 0